<template>
  <div>
    <div class="main_visual">
      <div class="admin_header_wrap">
        <header>
          <div class="logo">
            <h3>
              <span style="position: relative; top: 13px; margin-left: 0"
                >스마트회의 관리자</span
              >
            </h3>
          </div>
          <div class="r_menu">
            <ul class="top_left_menu">
              <li>
                <a class="f-white" @click="goPage('sMeeting')">사용자 페이지</a>
              </li>
              <!-- <li><a class="f-white" @click="goPage('myMeeting')">진행중인 회의</a></li>
                  <li><a class="f-white" @click="goPage('joinMeeting')">참여한 회의</a></li> -->
              <li><a @click="manualDownload()">매뉴얼</a></li>
              <!-- <li><button @click="logout()">시민참여회의</button></li> -->
            </ul>
          </div>
          <!-- r_menu -->
        </header>
      </div>
      <!-- //.header_wrap -->
    </div>
    <div style="position: absolute; margin-top: 63.5px; width: 100%">
      <v-divider></v-divider>
    </div>
    <manual-dialog
      :dialog="manualDialog.dialog"
      :closeDialog="closeManualDialog"
    />
  </div>
</template>
<script>
import Util from '@/util';
import ManualDialog from '@/components/popup/ManualDialog';
import moment from 'moment';
import timezone from 'moment-timezone';
import pkg from '../../package';
import SlideUpDown from 'vue-slide-up-down';

export default {
  name: 'app-toolbar',
  components: {
    ManualDialog,
    SlideUpDown,
  },
  data: () => ({
    langs: [
      {
        locale: 'kr',
        display: '한국어',
        imgSrc: '/static/images/kor.png',
        // 24x24
      },
      {
        locale: 'en',
        display: 'English',
        imgSrc: '/static/images/eng.png',
        // 24x24
      },
      // {
      //   locale: 'cn',
      //   display: 'Chinese',
      //   imgSrc: 'https://cdn.vuetifyjs.com/images/flags/cn.png'
      //   // 24x24
      // },
      // {
      //   locale: 'vn',
      //   display: 'Vietnam',
      //   imgSrc: 'https://flagcounter.com/images/flags/vn.png'
      //   // 16x11
      // },
      // {
      //   locale: 'sg',
      //   display: 'Singapore',
      //   imgSrc: 'https://flagcounter.com/images/flags/sg.png'
      //   // 16x11
      // }
    ],
    selectedLang: {},
    items: [
      // {
      //   icon: 'account_circle',
      //   href: '#',
      //   title: 'Profile',
      //   click: (e) => {
      //     window.getApp.$emit('APP_GO_PROFILE');
      //   }
      // },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Logout',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        },
      },
    ],
    noticeMsg: '',
    isNotice: false,
    manualDialog: {
      dialog: false,
    },
    interval: 5,
    webexHistory: {},
    useHidden: true,
    timing: '',
    duration: 500,
    active: false,
    loginUser: null,
    isAdmin: false,
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
  },
  watch: {
    '$store.state.route.name': {
      handler(val) {
        if (val) {
          this.noticeSetting();
        }
      },
    },
  },
  created() {
    if (!Util.hasSession(this, true)) return;
    this.noticeSetting();
    this.start();
    this.selectedLang = this.langs.find(
      (lang) => lang.locale === this.$i18n.locale
    );
    if (pkg.isHanwha) {
      this.items.pop();
    }

    if (this.$store.state.user) {
      this.loginUser = this.$store.state.user.username;
      this.isAdmin = this.$store.state.user.authorize === 'a' ? true : false;
    } else {
      this.loginUser = null;
      this.isAdmin = false;
    }
    this.selectedLang = this.$i18n.locale;
  },
  methods: {
    goHome() {
      if (this.$store.state.user) {
        this.$router.replace('/hero');
      }
    },
    async goPage(page) {
      let ssoStatus = (await this.$http.get('/api/auth/sso/status')).data.ssoStatus;

      if (page === 'sMeeting') {
        if (ssoStatus === 'dev') {
          window.location.href = 'https://ievm-smeeting-d.ksd.or.kr';
        } else {
          window.location.href = 'https://s-meeting.ksd.or.kr:8443';
        }
      } else {
        this.$router.replace('/' + page);
      }
    },
    langMouseEnter() {
      this.active = true;
    },
    langMouseLeave() {
      this.active = false;
    },
    setLocale(lang) {
      this.selectedLang = lang;
      this.$i18n.locale = this.selectedLang; // this.selectedLang.locale;
      this.$store.dispatch('setLocale', this.$i18n.locale);
    },
    korVersion() {
      console.log('korVersion');
    },
    engVersion() {
      console.log('engVersion');
    },
    profile() {
      this.$router.push({ name: 'Profile' });
    },
    personalAddress() {
      this.$router.push({ name: 'PersonalAddress' });
    },
    logout() {
      window.getApp.$emit('APP_LOGOUT');
    },
    goAdminPage() {
      this.$router.push({ name: 'Dashboard' });
    },
    async start() {
      let intervalMs = 5 * 60 * 1000; // 5분마다 새로고침
      this.interval = setInterval(() => {
        this.searchClick();
      }, intervalMs);
    },
    async searchClick() {
      let params = '';
      await this.$http
        .get('/api/v1/systems/history', { params: params })
        .then((response) => {
          let data = response.data;
          this.webexHistory = data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    async setHistory() {
      let params = {};
      if (this.webexHistory.actived === true) {
        return;
      }
      await this.$http
        .post('/api/v1/systems/history', params)
        .then((response) => {
          this.webexHistory.actived = response.data.webexHistory.actived;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    linkRssHistory() {
      this.$router.replace('/WebexHistory');
      this.setHistory();
    },
    handleDrawerToggle() {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
    async manualDownload() {
      this.manualDialog.dialog = true;
      // window.open('/api/v1/systems/manual', '_self');
    },
    closeManualDialog() {
      this.manualDialog.dialog = false;
    },
    async noticeSetting() {
      // Vue 오류로 주석
      // if (this.$store.state.user) {
      //   await this.$http.get('/api/v1/systems').then(response => {
      //     let settings = response.data;
      //     this.$store.dispatch('setSettings', settings);
      //   });
      //   if (this.$store.state.settings.systems.notice === '' || this.$store.state.settings.systems.notice === undefined) {
      //     this.noticeMsg = this.$t('page-header.notice-message', { name: this.$store.state.user.username });
      //   } else {
      //     if (moment() <= moment(this.$store.state.settings.systems.noticeDtime)) {
      //       this.noticeMsg = this.$store.state.settings.systems.notice;
      //       this.isNotice = true;
      //     }
      //     else {
      //       this.noticeMsg = this.$t('page-header.notice-message', { name: this.$store.state.user.username });
      //     }
      //   }
      // }
    },
  },
};
</script>

<style lang="stylus">
.notice-style {
  height: 64px;
  display: table;
  margin-left: 20px;
}

.notice-style i{
  display: table-cell;
  vertical-align: middle;
}

.notice-style span{
  display: table-cell;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminHeader.vue